/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExcelDownloadComponent} from './excel-download.component';

@NgModule({
    declarations: [ExcelDownloadComponent],
    exports: [
        ExcelDownloadComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ExcelDownloadModule {
}
